import { z } from 'zod';

/**
 * GET /case-reports/review-queue response shape — see elixaa-core
 * `caseReportService.listReviewQueue`. Each row carries the report
 * identity + denormalised author / client / session metadata so the
 * queue can render at a glance without N+1 user lookups.
 *
 * `clientFirstName` / `clientLastName` are nullable for anonymous
 * sessions (helpline, walk-in without contact info). Render
 * "Anonymous" when both are null.
 *
 * `status` is always `submitted` (the queue filter) — included for
 * type-safety only, not for display.
 */
export const reviewQueueRowSchema = z.object({
  id: z.string(),
  sessionId: z.string(),
  authorId: z.string(),
  clientId: z.string().nullish(),
  projectKey: z.enum(['campus_support', 'helpline_support', 'portal_helpline']),
  status: z.literal('submitted'),
  createdAt: z.string(),
  updatedAt: z.string(),
  authorFirstName: z.string().nullish(),
  authorLastName: z.string().nullish(),
  // Preferred display name when set; falls back to firstName + lastName.
  // Volunteers/listeners surface their chosen handle via this field.
  authorNickname: z.string().nullish(),
  clientFirstName: z.string().nullish(),
  clientLastName: z.string().nullish(),
  sessionScheduledStart: z.string(),
  sessionMode: z.enum(['online', 'in_person', 'helpline']),
});
export type ReviewQueueRow = z.infer<typeof reviewQueueRowSchema>;

export const reviewQueueResponseSchema = z.array(reviewQueueRowSchema);
